// The Phase 2 coverage-option toggle that represents each LOB (region suffix
// appended at lookup). Single source for the LOB↔coverage-key relationship.
const COVERAGE_BY_LOB: Record<string, string> = {
  GL: 'CGL',
  EO: 'EOMock'
};

const REGIONS = ['US', 'CA'];

const coverageKey = (coverage: string, region: string): string =>
  `Coverage_Munich_201_9219_${coverage}_${region}_EN`;

// Coverage-option keys for LOBs OTHER than the given one (both regions). Used to
// hide/clear/strip the non-owned coverage so a single-LOB endorsement stays
// scoped to one LOB. Returns [] for an unknown lobType (no-op, never over-strips).
export const getSiblingCoverageKeys = (lobType: string): string[] => {
  if (!(lobType in COVERAGE_BY_LOB)) return [];
  return Object.entries(COVERAGE_BY_LOB)
    .filter(([lob]) => lob !== lobType)
    .flatMap(([, coverage]) =>
      REGIONS.map((region) => coverageKey(coverage, region))
    );
};
